module.exports = __webpack_public_path__ + "static/media/greenBack7.0ddaaba2.jpg";